const now = () => {
  const [date, time] = new Date().toISOString().split(/[T.]/);
  return `${date} ${time}`;
};

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const browserConsole = globalThis.console;

const writeLog = (level: LogLevel, ...args: unknown[]) => {
  browserConsole[level](now(), `[${level.toUpperCase()}]`, ...args);
};

const logger = {
  debug: (...args: unknown[]) => writeLog('debug', ...args),
  info: (...args: unknown[]) => writeLog('info', ...args),
  warn: (...args: unknown[]) => writeLog('warn', ...args),
  error: (...args: unknown[]) => writeLog('error', ...args),
};

export default logger;
